export class HeaderCell {
    constructor(
        public fieldId?: number,
        public value?: string,
        public width?: number,
        public description?: string) { }
}
